import React from 'react';
import PropTypes from 'prop-types';

const iconDelivery = ({ className }) => (
    <svg
      width="40px"
      className={className}
      height="21px"
      viewBox="0 0 40 21"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinejoin="bevel"
      >
        <g
          transform="translate(-397.000000, -2576.000000)"
          stroke="#27919C"
          strokeWidth="2"
        >
          <g id="icon_delivery" transform="translate(398.000000, 2577.000000)">
            <line x1="0" y1="9.5" x2="16" y2="9.5" id="Stroke-1" />
            <polyline id="Stroke-3" points="29 0 38 9.49952018 29 19" />
            <polyline id="Stroke-5" points="9 19 0 9.50047982 9 0" />
            <line x1="22" y1="9.5" x2="37" y2="9.5" id="Stroke-7" />
          </g>
        </g>
      </g>
    </svg>
  );

iconDelivery.propTypes = {
  className: PropTypes.string
}

export default iconDelivery;
